export const toasterNotifications = {
    // Auth
    login: {
        loading: 'Lütfen Bekleyin',
        success: 'Hoş Geldiniz!',
        error: 'Bir hata oluştu!',
    }, 
    signup: {
        loading: 'Lütfen Bekleyin',
        success: 'Kayıt Başarılı!',
        error: 'Bir hata oluştu!',
    },

    // Product
    addProduct: {
        loading: 'Lütfen Bekleyin',
        success: 'Ürün Eklendi!',
        error: 'Bir hata oluştu!',
    }, 
    deleteProduct: {
        loading: 'Lütfen Bekleyin',
        success: 'Ürün başarıyla silindi!',
        error: 'Bir hata oluştu!',
    }, 
    editProduct: {
        loading: 'Lütfen Bekleyin',
        success: 'Ürün başarıyla güncellendi!',
        error: 'Bir hata oluştu!',
    }, 

    // Work Orders
    addWorkOrder: {
        loading: 'Lütfen Bekleyin',
        success: 'İş emri eklendi!',
        error: 'Bir hata oluştu!',
    }, 
    deleteWorkOrder: {
        loading: 'Lütfen Bekleyin',
        success: 'İş emri başarıyla silindi!',
        error: 'Bir hata oluştu!',
    },

    // Enamel Painting
    addEnamelPainting: {
        loading: 'Lütfen Bekleyin',
        success: 'Emaye boyama iş emri eklendi!',
        error: 'Bir hata oluştu!',
    }, 
    deleteEnamelPainting: {
        loading: 'Lütfen Bekleyin',
        success: 'Emaye boyama iş emri başarıyla silindi!',
        error: 'Bir hata oluştu!',
    }
}